<template>
  <div class="followWrap">
    <div class="main ex">
      <div class="header twoBtn">
        <a class="backBtn" @click="$router.go(-1)">
          <i class="icon_back"></i> {{ $t('back') }}
        </a>
        <a class="toggleModeBtn" @click="changeMode">
          {{ $t('exhibitionListPage.toggle') }}
          {{ mode === 'list' ? $t('exhibitionListPage.numberMode') : $t('exhibitionListPage.listMode') }}
        </a>
      </div>
      <div class="followBox listMode" v-if="mode === 'list'">
        <div class="contentList">
          <ul v-if="navigationList.length > 0">
            <li v-for="navigation in navigationList" :key="navigation.guideCode">
              <template v-if="navigation && navigation.guideContent && navigation.guideContent.title">
                <a @click="openFollowPlayWrap(navigation.guideContent, navigation.guideCode, 'list')">
                  <div class="listBox">
                    <div class="picBox">
                      <div class="pic" v-if="navigation.guideContent.logo">
                        <img :src="navigation.guideContent.logo" alt="guide content's logo"/>
                      </div>
                    </div>
                    <div class="textBox">
                      <div class="titie">{{ $t('exhibitionListPage.title') }} {{ navigation.guideContent.title }}</div>
                      <div class="subtitle"> {{ navigation.guideContent.desc }} </div>
                    </div>
                  </div>
                </a>
              </template>
              <div v-else class="noData">
                <div v-html="$t('exhibitionListPage.errorTip')"/>
                <div class="pa-2" v-if="navigation.guideCode">
                  {{ `( ${ $t('exhibitionListPage.exhibitionCode') }：${navigation.guideCode} )` }}
                </div>
              </div>
            </li>
          </ul>
          <div v-else class="noData">{{ $t('exhibitionListPage.errorTip') }}</div>
        </div>
      </div>
      <div class="followBox numberMode" v-else>
        <div class="subText">{{ $t('exhibitionListPage.inputTip') }}</div>
        <div class="exNum">{{ navigationInputCode }}</div>
        <div class="inputArea">
          <div class="inputBox">
            <div class="inputLine">
              <a @click="inputCode('1')" class="inputBtn">1</a>
              <a @click="inputCode('2')"  class="inputBtn">2</a>
              <a @click="inputCode('3')"  class="inputBtn">3</a>
            </div>
            <div class="inputLine">
              <a @click="inputCode('4')"  class="inputBtn">4</a>
              <a @click="inputCode('5')"  class="inputBtn">5</a>
              <a @click="inputCode('6')"  class="inputBtn">6</a>
            </div>
            <div class="inputLine">
              <a @click="inputCode('7')"  class="inputBtn">7</a>
              <a @click="inputCode('8')"  class="inputBtn">8</a>
              <a @click="inputCode('9')"  class="inputBtn">9</a>
            </div>
            <div class="inputLine">
              <a @click="inputCode('clear')"  class="inputBtn">C</a>
              <a @click="inputCode('0')"  class="inputBtn">0</a>
              <a @click="confirmCode" class="inputBtn confirm">{{ $t('exhibitionListPage.cofirm') }}</a>
            </div>
          </div>
        </div>
      </div>

      <div class="playBoxBottom" v-if="bottomNavigationInfo.code">
        <a @click="openFollowPlayWrap(bottomNavigationInfo, null, 'bottom')">
          <div class="playcover">
            <img :src="bottomNavigationInfo.logo" alt="logo" />
          </div>
          <div class="playtitle">{{ bottomNavigationInfo.title }}</div>
          <span class="playstatus">
            <img style="height: 100%;" :src="!bottomNavigationInfo.isPlaying ? playIcon : pauseIcon" alt="icon for play status" />
          </span>
        </a>
      </div>

      <div class="followPlayWrap" :class="followPlayWrapClass" v-if="followPlayWrapInfo">
        <a @click="isFollowPlayWrapShow = false" class="close">
          <span class="downarrow"></span>
        </a>
        <div class="contentBox">
          <div class="contentBoxInner">
            <div class="contentCover" v-if="navigationInfo.visualIdentityImage">
              <img :src="navigationInfo.visualIdentityImage" :alt="$t('exhibitionListPage.imgAlt')" />
            </div>
            <div class="contentTimeLine"></div>
            <div class="contentExTitle">{{ navigationInfo.showLocalName }}</div>
            <div class="contentExName">{{ $t('exhibitionListPage.title') }}{{ followPlayWrapInfo.title }}</div>
            <youtube v-if="followPlayWrapInfo.type === 'video'"
                    player-width="100%"
                    :video-id="getIdFromURL(followPlayWrapInfo.mediaPath)"
                    @playing="handleMediaStatus(true)"
                    @paused="handleMediaStatus(false)"/>
            <audio v-else
                   controls
                   :src="followPlayWrapInfo.mediaPath"
                   @play="handleMediaStatus(true)"
                   @pause="handleMediaStatus(false)"/>
            <div class="contentSoundBox"></div>
            <div class="contentTextBox">
              {{ followPlayWrapInfo.desc }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import playIcon from '@/assets/images/play.svg'
import pauseIcon from '@/assets/images/pause.svg'
import { mapGetters, mapActions } from 'vuex'

const followPlayWrapInfo = {
  code: '',
  logo: '',
  title: '',
  desc: '',
  mediaPath: '',
  type: '',
  isPlaying: false,
  youtubeId: '',
}
export default {
  data() {
    return {
      // 展覽基本資料
      navigationInfo: {
        showLocalName: '',
        visualIdentityImage: '',
      },
      mode: 'list', // list or number
      // 展覽列表
      navigationList: [],
      // 展覽編號輸入框
      navigationInputCode: '',
      isFollowPlayWrapShow: false,
      isFollowPlayWrapClicked: false,
      followPlayWrapInfo: cloneDeep(followPlayWrapInfo),
      bottomNavigationInfo: cloneDeep(followPlayWrapInfo),
      currentPlayNumber: '',
      playIcon,
      pauseIcon,
    }
  },
  created() {
    this.init()
  },
  computed: {
    ...mapGetters([
      'lang',
    ]),
    followPlayWrapClass() {
      let className = ''
      if (this.isFollowPlayWrapClicked) {
        if (this.isFollowPlayWrapShow) {
          className = 'active'
        } else {
          className = 'inactive'
        }
      }
      return className
    },
    followPlayWrapPlayStatus() {
      return this.bottomNavigationInfo.code === this.followPlayWrapInfo.code
              && this.bottomNavigationInfo.isPlaying
    },
  },
  methods: {
    ...mapActions([
      'trackerLog',
    ]),
    init() {
      this.getNavigationInfo()
      this.getNavigationList()
    },
    getNavigationInfo() {
      if (localStorage.getItem('projectInfo')) {
        this.navigationInfo = JSON.parse(localStorage.getItem('projectInfo'))
      }
    },
    getNavigationList() {
      if (localStorage.getItem('guideRepertoire')) {
        const navigationList = JSON.parse(localStorage.getItem('guideRepertoire'))
        this.navigationList = navigationList.map((navigation) => {
          const currentLangGuideContent = navigation.guideContent.find((guideContent) => guideContent.language === this.lang.toUpperCase())
          return {
            ...navigation,
            guideContent: currentLangGuideContent,
          }
        })
      }
    },
    changeMode() {
      if (this.mode === 'list') {
        this.mode = 'number'
      } else {
        this.mode = 'list'
      }
    },
    inputCode(val) {
      if (val === 'clear') {
        this.navigationInputCode = ''
      } else {
        this.navigationInputCode += val
      }
    },
    confirmCode() {
      const currentNavigation = this.navigationList.find((navigation) => navigation.guideCode === this.navigationInputCode)
      if (currentNavigation) {
        this.openFollowPlayWrap(currentNavigation.guideContent, currentNavigation.guideCode, 'number')
      } else {
        this.$alert.wraningAlert(this.$t('exhibitionListPage.notFound'))
      }
    },
    openFollowPlayWrap(navigationInfo, code, mode) {
      // clear followPlayWrapInfo
      this.followPlayWrapInfo = cloneDeep(followPlayWrapInfo)
      // set
      this.isFollowPlayWrapClicked = true
      this.isFollowPlayWrapShow = true
      this.followPlayWrapInfo = navigationInfo
      if (code) this.followPlayWrapInfo.code = code

      // log
      this.trackerLog({
        event: 'click_exhibition_media',
        message: {
          mediaId: this.followPlayWrapInfo.code,
          media: this.followPlayWrapInfo.title,
          mode,
          exhibitionId: localStorage.getItem('projectCode'),
          exhibition: this.navigationInfo.showLocalName,
        },
      })
    },
    closeFollowPlayWarp() {
      this.isFollowPlayWrapShow = false
    },
    handleMediaStatus(isPlay) {
      if (this.bottomNavigationInfo.code !== this.followPlayWrapInfo.code) {
        this.bottomNavigationInfo = this.followPlayWrapInfo
      }
      this.$set(this.bottomNavigationInfo, 'isPlaying', isPlay)

      // log
      this.trackerLog({
        event: 'control_media',
        message: {
          mediaId: this.followPlayWrapInfo.code,
          media: this.followPlayWrapInfo.title,
          mode: isPlay ? 'play' : 'pause',
          exhibitionId: localStorage.getItem('projectCode'),
          exhibition: this.navigationInfo.showLocalName,
        },
      })
    },
    getIdFromURL(url) {
      const youtubeRegexp = /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\S*[^\w\s-])([\w-]{11})(?=[^\w-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/ig
      let id = url.replace(youtubeRegexp, '$1')
      if (id.includes(';')) {
        const pieces = id.split(';')
        if (pieces[1].includes('%')) {
          const uriComponent = decodeURIComponent(pieces[1])
          id = (`http://youtube.com${uriComponent}`).replace(youtubeRegexp, '$1')
        } else {
          [id] = pieces
        }
      } else if (id.includes('#')) {
        [id] = id.split('#')
      }
      return id
    },
  },
}
</script>
